import { useEffect, useState } from "react";
import QRCode from "qrcode";

/**
 * QR-Code als SVG — geteilte Version für Stellen außerhalb der Slides (z. B.
 * der persönliche Ergebnis-Link in MobileSubmittedHero).
 *
 * Kopie der QR-Rendering-Logik aus `frontend/src/offsites/ar/slides/_zugang.tsx`
 * (Funktion `QrCode`). Dort bewusst NICHT angefasst — an `ar/` arbeitet
 * aktuell niemand, und das Zusammenlegen zu einem einzigen Modul (das dort
 * dann re-exportiert würde) ist eine bewusste spätere Aufräumarbeit, keine
 * Eile für diesen Task. Unterschied zum Original: nimmt die zu kodierende
 * URL als Prop (`value`) statt sie intern aus der Workshop-Login-URL zu
 * bauen — dieser Ort braucht beliebige Links, nicht nur den Login-QR.
 */
export function QrCode({
  value,
  klein = false,
}: {
  value: string;
  klein?: boolean;
}) {
  const [svg, setSvg] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toString(value, {
      type: "svg",
      errorCorrectionLevel: "H",
      margin: 0,
      color: { dark: "#161B21", light: "#FFFFFF" },
    })
      .then((s) => {
        if (!cancelled) setSvg(s);
      })
      .catch(() => {
        if (!cancelled) setSvg(null);
      });
    return () => {
      cancelled = true;
    };
  }, [value]);

  return (
    <div className={`ar-qr${klein ? " ar-qr-klein" : ""}`}>
      {svg ? (
        <span
          aria-hidden="true"
          style={{ display: "block", width: "100%", height: "100%" }}
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      ) : (
        <div className="ar-qr-fallback">QR-Code wird erzeugt …</div>
      )}
    </div>
  );
}
